import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 401,
  name: 'Unauthorized',
  description:
    'The request lacks valid authentication credentials. The server requires the client to authenticate before accessing the resource. Despite the name, this is about authentication (who you are), not authorization (what you can do).',
  causes: [
    'No authentication token, API key, or session cookie was included in the request.',
    'The token or credentials have expired. JWTs, OAuth tokens, and session cookies all have expiration times.',
    'The API key or Bearer token is malformed, revoked, or belongs to a different environment (e.g., using a staging key in production).',
  ],
  fixes: [
    'Include valid credentials in the request. For APIs, add an Authorization header (e.g., Authorization: Bearer <token>).',
    'If the token expired, refresh it. For OAuth, use the refresh token flow. For sessions, redirect the user to log in again.',
    'Verify you are using the correct API key for the environment. Check that the key has not been rotated or revoked.',
  ],
  monitoringTip:
    'Uptrack can monitor authenticated endpoints by including custom headers in its checks. If your auth system breaks and valid tokens get rejected, Uptrack detects the 401 within 30 seconds and alerts you once several locations confirm it.',
}

export const Route = createFileRoute('/_site/http/401')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
